import React, {Fragment, Component} from 'react';
import PropTypes from 'prop-types';
import {PeopleOnline, InfiniteScroller, ThemeContext, Avatar} from '../../common';

export default class LeaderboardContent extends Component {
  static propTypes = {
    leaders: PropTypes.shape({
      hasMore: PropTypes.bool.isRequired,
      list: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      currentPlayer: PropTypes.shape({
        points: PropTypes.number,
      }).isRequired,
    }).isRequired,
    onFetchPlayersForLeaderboard: PropTypes.func.isRequired,
    showPeopleOnline: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    showPeopleOnline: false,
  }

  componentDidMount() {
    this.props.onFetchPlayersForLeaderboard({resetPage: true});
  }

  renderCurrentUserPoints = () => {
    const {leaders: {currentPlayer: {points = 0}}} = this.props;

    return (
      <div className="text-center text-xxxx-big text-light">
        Your points: <b>{points}</b>
      </div>
    );
  };

  renderRows = (players, pointStyles) => players.map((player) => {
    const fullName = `${player.firstName} ${player.lastName}`;

    return (
      <div key={player.id} className="player row row_space-between row_vcenter">
        <div className="cell row row_vcenter">
          <div className="player__avatar">
            <Avatar image={player.image} fullName={fullName} iconSize="45" imageWidth={100}/>
          </div>
          <span className="player__name">{fullName}</span>
        </div>
        <div className="cell cell_auto">
          <span className="player__points" style={pointStyles}>{Math.ceil(player.totalPoints)}</span>
        </div>
      </div>
    );
  });

  render() {
    const {
      showPeopleOnline, onFetchPlayersForLeaderboard,
      leaders: {hasMore, list},
    } = this.props;

    return (
      <ThemeContext.Consumer>
        {(theme) => {
          const styles = {color: theme.primaryColor};
          const pointStyles = {
            color: theme.secondaryColor,
          };

          return (
            <Fragment>
              <div className="row row_space-between players-list-header">
                <div className="cell">Player</div>
                <div className="cell text-right">
                  <span className="players-list-header__points">Points</span>
                </div>
              </div>
              <div className="row row_space-between">
                <div className="cell players-list-wrapper">
                  <div className="players-list">
                    <div className="players-list__content custom-overflow" style={styles}>
                      <InfiniteScroller
                        loadMore={onFetchPlayersForLeaderboard}
                        hasMore={hasMore}
                      >
                        {this.renderRows(list, pointStyles)}
                      </InfiniteScroller>
                    </div>
                  </div>
                </div>
                {showPeopleOnline ?
                  <div className="cell cell_auto people-online-wrapper">
                    <PeopleOnline/>
                  </div> : <div/>
                }
              </div>
            </Fragment>
          );
        }}
      </ThemeContext.Consumer>
    );
  }
}
